import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authorization-gate/orgs/$orgName/')({
	beforeLoad: () => {
		throw redirect({ from: '/orgs/$orgName/', to: './projects' });
	},
});
